import type { TerminologyLibrary } from '#src/terminology/types.ts'

// How a standard code relates to ours, in FHIR R4 ConceptMap terms. The
// direction is the standard code's: `wider` means the standard code covers
// more than our code does.
export const MAPPING_RELATIONSHIPS = [
  'equivalent',
  'wider',
  'narrower',
  'relatedto',
  'unmatched',
] as const
export type MappingRelationship = (typeof MAPPING_RELATIONSHIPS)[number]

export interface ConceptMapping {
  system: string
  // Absent when the relationship is `unmatched`.
  code?: string
  display?: string
  relationship: MappingRelationship
  comment?: string
}

export function conceptMappings(
  library: TerminologyLibrary,
  sourceSystem: string,
  code: string
): ConceptMapping[] {
  return (library.conceptMap.group ?? []).flatMap((group) =>
    group.source !== sourceSystem || !group.target
      ? []
      : (group.element ?? [])
          .filter((element) => element.code === code)
          .flatMap((element) =>
            (element.target ?? []).map((target) => ({
              system: group.target ?? '',
              code: target.code,
              display: target.display,
              relationship: relationship(target.equivalence),
              comment: target.comment,
            }))
          )
  )
}

function relationship(value: string | undefined): MappingRelationship {
  return (
    MAPPING_RELATIONSHIPS.find((candidate) => candidate === value) ??
    'relatedto'
  )
}
